var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { accountBadgeBackImageAttachmentKey, accountBadgeEntityName, accountBadgeFrontImageAttachmentKey, accountBadgePrintedAttachmentKey, } from '../../../../backend/features/badges/shared';
import { useBadgingTranslation } from '../../../../ui/hooks';
import { getBadgeFileName } from '../../../../ui/util/getBadgeFileName';
import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { handleErrorSnackbar } from '@juvare/common-web-ui/SnackbarHelper';
import { Image } from '@juvare/platform-sdk-react/ui/components';
import { downloadFile } from '@juvare/platform-sdk-react/ui/utils';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import FlipOutlinedIcon from '@mui/icons-material/FlipOutlined';
import { Box, Button, DialogActions, DialogContent, DialogTitle, Stack } from '@mui/material';
import React from 'react';
import { BadgePreviewContextProvider } from '../contexts/BadgePreviewContext';
export const BadgePreviewAttachmentModal = ({ ariaTitleId, ariaContentId, entityId, accountDisplayName, badgePreviewContext, close, printStatus, }) => {
    const { t } = useBadgingTranslation();
    const [isBackTemplateVisible, setIsBackTemplateVisible] = React.useState(false);
    const handleFlipTemplate = () => {
        setIsBackTemplateVisible((prevState) => !prevState);
    };
    const handleDownloadPDF = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            yield downloadFile({
                entity: accountBadgeEntityName,
                entityId: entityId,
                key: accountBadgePrintedAttachmentKey,
                downloadFileName: getBadgeFileName(accountDisplayName),
            });
        }
        catch (error) {
            handleErrorSnackbar(error);
        }
    });
    return (React.createElement(BadgePreviewContextProvider, Object.assign({}, badgePreviewContext),
        React.createElement(DialogTitle, { id: ariaTitleId }, t('badgePreview.previewModalTitle', {
            title: accountDisplayName,
        })),
        React.createElement(DialogContent, { sx: {
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
            }, id: ariaContentId },
            React.createElement(Box, { sx: {
                    px: 5,
                    py: 2,
                    borderRadius: 1,
                    backgroundColor: themeColors.surface.secondary,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: 2,
                } },
                React.createElement(Image, { entity: accountBadgeEntityName, entityId: entityId, attachmentKey: isBackTemplateVisible ? accountBadgeBackImageAttachmentKey : accountBadgeFrontImageAttachmentKey, sx: { width: '100%', border: 2, borderColor: themeColors.border.main, borderRadius: 1 } }),
                React.createElement(Stack, { direction: 'row', spacing: 2 },
                    React.createElement(Button, { startIcon: React.createElement(FlipOutlinedIcon, null), onClick: handleFlipTemplate }, t('badgePreview.flipBadge')),
                    printStatus === 'success' && (React.createElement(Button, { startIcon: React.createElement(FileDownloadOutlinedIcon, null), onClick: () => void handleDownloadPDF() }, t('badgePreview.downloadPDF')))))),
        React.createElement(DialogActions, null,
            React.createElement(Button, { variant: 'text', color: 'primary', onClick: () => close() }, t('badges.badgeCard.close')))));
};
